import React from 'react';
import PropTypes from 'prop-types';
import { Button, Tooltip } from '@statsbomb/kitbag-components';
import { LinkButtonWrapper } from './LinkButton.styles';

/**
 * LinkButton component
 * This component is a button that behaves like a link, allowing navigation to different routes.
 */
const LinkButton = ({
  label = '',
  onClickFn = () => {},
  tooltip = '',
  testId = '',
}) => (
  <LinkButtonWrapper>
    <Tooltip
      content={
        <div style={{ width: '75px', textAlign: 'center' }}>{tooltip}</div>
      }
      placement="top-centre"
    >
      <Button onClick={onClickFn} variant="link" testId={testId}>
        {label}
      </Button>
    </Tooltip>
  </LinkButtonWrapper>
);

LinkButton.propTypes = {
  label: PropTypes.string,
  onClickFn: PropTypes.func,
  testId: PropTypes.string,
  tooltip: PropTypes.string,
};

export default LinkButton;
